// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-container {
  position: relative;
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
}
.register-container .logo {
  z-index: 1000;
  position: relative;
  padding: 0px 55px;
}
.register-container .ant-row {
  justify-content: center;
}
.register-container .username-register {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 20px;
}
.register-container .regist-form {
  position: relative;
  background: rgba(255, 255, 255, 0.96);
}
.provicy-style pre {
  height: 350px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  border: 1px solid black;
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.15;
}
@media (min-width: 0) and (max-width: 640px) {
  .register-container .logo-box {
    padding: 0px 20px;
    margin-top: 15px;
  }
  .register-container .regist-form {
    width: 90%;
    height: auto;
    padding: 5px 15px;
    max-width: 100%;
    margin: 0px auto 0px;
  }
}
@media (min-width: 640px) {
  .register-container .logo-box {
    padding: 0px 55px;
    margin-top: 15px;
  }
  .register-container .regist-form {
    width: 40%;
    min-width: 600px;
    margin: auto;
    padding: 10px 15px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Components/VppAssociatedSystem/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AALA;EAMI,aAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;AAVA;EAWI,uBAAA;AAEJ;AAbA;EAcI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAEJ;AApBA;EAqBI,kBAAA;EACA,qCAAA;AAEJ;AAEA;EAEI,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AADJ;AAKA;EACE;IAEI,iBAAA;IACA,gBAAA;EAJJ;EACA;IAMI,UAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,oBAAA;EAJJ;AACF;AAQA;EACE;IAEI,iBAAA;IACA,gBAAA;EAPJ;EAIA;IAMI,UAAA;IACA,gBAAA;IACA,YAAA;IACA,uBAAA;EAPJ;AACF","sourcesContent":[".register-container {\n  position: relative;\n  min-height: 100vh;\n  max-width: 100vw;\n  overflow-x: hidden;\n  .logo {\n    z-index: 1000;\n    position: relative;\n    padding: 0px 55px;\n  }\n  .ant-row {\n    justify-content: center;\n  }\n  .username-register {\n    text-align: center;\n    font-size: 18px;\n    font-weight: bold;\n    color: #000000;\n    margin-bottom: 20px;\n  }\n  .regist-form {\n    position: relative;\n    background: rgba(255, 255, 255, 0.96);\n  }\n}\n\n.provicy-style {\n  pre {\n    height: 350px;\n    overflow-y: auto;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    border: 1px solid black;\n    font-family: sans-serif;\n    font-size: 14px;\n    line-height: 1.15;\n  }\n}\n\n@media (min-width: 0) and (max-width: 640px) {\n  .register-container {\n    .logo-box {\n      padding: 0px 20px;\n      margin-top: 15px;\n    }\n    .regist-form {\n      width: 90%;\n      height: auto;\n      padding: 5px 15px;\n      max-width: 100%;\n      margin: 0px auto 0px;\n    }\n  }\n}\n\n@media (min-width: 640px) {\n  .register-container {\n    .logo-box {\n      padding: 0px 55px;\n      margin-top: 15px;\n    }\n    .regist-form {\n      width: 40%;\n      min-width: 600px;\n      margin: auto;\n      padding: 10px 15px 10px;\n    }\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
